export class Config {
  public static ServiceBaseUrl = 'https://api.yaujna.com/';
  public static projectName = 'YAUJNA';
  public static projectLogoUrl = '';
  public static footerText = 'Copyrights Reserved';
  public static navigationType = 'horizontal-navigation';
  public static DocumentBaseUrl = 'https://api.yaujna.com/';
}
